export default __webpack_public_path__ + "static/doki-2c029a4f6ac5808cd41f58089dc4c408.png";